module.exports = (parcelRequire.load("k5JYs")).then(() => parcelRequire('4CO4e'));